import { render, staticRenderFns } from "./WordPreviewComponent.vue?vue&type=template&id=68ec8b53&scoped=true&lang=pug"
import script from "./WordPreviewComponent.vue?vue&type=script&lang=ts"
export * from "./WordPreviewComponent.vue?vue&type=script&lang=ts"
import style0 from "./WordPreviewComponent.vue?vue&type=style&index=0&id=68ec8b53&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ec8b53",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68ec8b53')) {
      api.createRecord('68ec8b53', component.options)
    } else {
      api.reload('68ec8b53', component.options)
    }
    module.hot.accept("./WordPreviewComponent.vue?vue&type=template&id=68ec8b53&scoped=true&lang=pug", function () {
      api.rerender('68ec8b53', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FileManager/Preview/components/WordPreviewComponent.vue"
export default component.exports